const allProducts = []

const vendor = {
  "IV His Glory" : "https://ivhisglory.com/products/",
  "Native Supply" : "https://native.supply/collections/all/products/",
  "Beacon Threads": "https://www.beaconthreads.com/products/",
  "Beacon Threads Deals": "https://www.beaconthreads.com/products/",
  "TrustGodBro Apparel": "https://www.shoptrustgodbro.com/products/",
  "Reborn Kings" : "https://rebornkings.com/products/",
  "Elevated Faith": "https://elevatedfaith.com/products/",
  "Kidan Clothing": "https://kidanclothing.com/products/",
  "Salt and Light Merch": "https://saltandlightmerch.com/products/",
  "Forty-Six Ten Apparel": "https://fortysixten.net/products/",
  "Nhim Apparel": "https://nhimapparel.com/products/",
  "BOLD Apparel": "https://boldapparel.com/products/",
}


export async function fetchProducts(force = false) {
  // Only fetch if the array is empty OR force fetch is requested
  if (allProducts.length < 1 || force) {
    const url = "https://render-suq-backend.onrender.com/products";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // read the raw text
      const text = await response.text();

      // if the body is empty, treat it as an empty array
      const data = text
        ? /** safe-parse the JSON text */
          JSON.parse(text)
        : [];

      // If we're refetching, clear the array first
      if (force) {
        allProducts.length = 0;
      }

      // Before pushing, ensure we don't add duplicates
      const uniqueProducts = data.filter(
        newProduct => !allProducts.some(
          existing => existing.product_id === newProduct.product_id
        )
      );
      
      allProducts.push(...uniqueProducts);
      
      // Log how many products we loaded
      console.log(`Loaded ${uniqueProducts.length} products (${allProducts.length} total)`);
      
      return [...allProducts]; // Return a copy of the array
    } catch (error) {
      console.error("Failed to fetch products:", error);
      throw error; 
    }
  }
  
  return [...allProducts]; // Return a copy to prevent mutation
}

// export async function fetchProducts() {
//   const url = "https://render-suq-backend.onrender.com/products";

//   try {
//     const response = await fetch(url);
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }

//     // read the raw text
//     const text = await response.text();

//     // if the body is empty, treat it as an empty array
//     const data = text
//       ? /** safe-parse the JSON text */
//         JSON.parse(text)
//       : [];

//     allProducts.push(...data);
//     return data;
//   } catch (error) {
//     console.error("Failed to fetch products:", error);
//     throw error; 
//   }
// }


export function getAllProducts() {
    return allProducts;
  }

// export async function getProductsByCategory(category) {
//     if (allProducts.length === 0) {
//         await fetchProducts(); // Fetch products if the array is empty
//     }
//   return allProducts
//     .filter(product => (product.product_type === category && product.vendor !== "Native Supply" && product.vendor !== "TrustGodBro Apparel") || category === "All Products")
//     .map(product => ({
//       imageUrl: product.featured_image?.src ? product.featured_image?.src : product.images[0]?.src,
//       discount: product.variants[0]?.discount,
//       brand: product.vendor,
//       title: product.title,
//       price: product.variants[0]?.price,
//       originalPrice: product.variants[0]?.compare_at_price,
//       link: vendor[product.vendor]+product.handle,
//     }));
// }


function getFirstImageUrl(image_urls) {
  if (Array.isArray(image_urls) && image_urls.length > 0) {
    return image_urls[0];
  }
  if (typeof image_urls === "string" && image_urls) {
    return image_urls;
  }
  return ""; // fallback if no image
}

export async function getProductsByCategory(category) {
  if (allProducts.length === 0) {
    // allProducts.push(...(await fetchProducts())); // Fetch products if the array is empty
    await fetchProducts();
  }

  // Filter products by category
  const filteredProducts = allProducts.filter(
    product =>
      product.productType === category || category === "All Products"
  );
 
  if (category === "T-shirt" || category === "Hoodie" || category === "Sweatshirt" || category === "Long Sleeve Shirt") {
    filteredProducts.sort((a, b) => {
    const aVotes = a.rating_values_length ?? 0;
    const bVotes = b.rating_values_length ?? 0;

    const aAvg = a.rating_score ?? 0;
    const bAvg = b.rating_score ?? 0;

    // Relevance formula: favors high rating & more votes
    const aScore = aAvg * (1 + Math.log10(aVotes + 1));
    const bScore = bAvg * (1 + Math.log10(bVotes + 1));

    console.log(`Product A: votes=${aVotes}, avg=${aAvg}, score=${aScore.toFixed(2)}`);

    return bScore - aScore; // Sort descending
  });

  return filteredProducts
  }

  // Randomize the order of the filtered products
  for (let i = filteredProducts.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [filteredProducts[i], filteredProducts[j]] = [filteredProducts[j], filteredProducts[i]];
  }

  return filteredProducts;
}

export async function searchProducts(query) {
  console.log("Searching for:", query);

   const url = `https://render-suq-backend.onrender.com/search?q=${encodeURIComponent(query)}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.text();
    const data = text ? JSON.parse(text) : [];

    return data.map(product => ({
      id: product.product_id,
      images: product.image_urls,
      imageUrl: product.image_urls?.[0],
      brand: product.brand,
      title: product.title,
      price: product.price,
      originalPrice: product.compare_at_price,
      productType: product.product_type,
      link: vendor[product.brand] + product.handle,
    }));
  } catch (error) {
    console.error("Search failed:", error);
    return [];
  }
}
